import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSparkle3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sparkle-3, ai, star, magic"} maskId="square-filled-radius-0-stroke-1-IconSparkle3"><path d="M13.417 2.32031L15.7119 8.28711L21.6797 10.583L22 10.707V13.293L21.6797 13.417L15.7119 15.7119L13.417 21.6797L13.293 22H10.707L10.583 21.6797L8.28711 15.7119L2.32031 13.417L2 13.293V10.707L2.32031 10.583L8.28711 8.28711L10.583 2.32031L10.707 2H13.293L13.417 2.32031Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSparkle3;
